<h1 class="e-title-xs">{{ outage().city }}, {{ outage().municipality }} kommune</h1>
@switch (outage().type) {
  @case ('Unplanned') {
    <dl>
      <dt>Oppdaget</dt>
      <dd>
        <time [attr.datetime]="outage().unplannedRegisteredDate?.toISOString()">
          {{ outage().unplannedRegisteredDate | dateWithFallback }}
        </time>
      </dd>
      <dt>Antall berørte</dt>
      <dd>{{ outage().affectedCustomers | number }}</dd>
      <dt>Status</dt>
      <dd>Strømbruddet er kjent. Personell jobber med å lokalisere og rette feilen.</dd>
    </dl>
  }
  @case ('Planned') {
    <dl>
      <dt>Planlagt fra</dt>
      <dd>
        <time [attr.datetime]="outage().plannedRectifyStart?.toISOString()">
          {{ outage().plannedRectifyStart | dateWithFallback }}
        </time>
      </dd>
      <dt>Planlagt til</dt>
      <dd>
        <time [attr.datetime]="outage().plannedRectifyEnd?.toISOString()">
          {{ outage().plannedRectifyEnd | dateWithFallback }}
        </time>
      </dd>
      <dt>Antall berørte</dt>
      <dd>{{ outage().affectedCustomers | number }}</dd>
      <dt>Status</dt>
      <dd>{{ plannedStatusText() }}</dd>
    </dl>
  }
}
